import { useConsentTrust } from './hooks';
import { ConsentTrustTemplate } from 'views/components/templates/establishes';
import { Gauge, GaugeSP, getGaugeValue } from 'views/components/atoms/gauge';
import { useLocation } from 'react-router-dom';

export const ConsentTrust = () => {
  const tempProps = useConsentTrust();
  const location = useLocation();

  return (
    <form className="establishFormSP" onSubmit={tempProps.formik.handleSubmit}>
      <GaugeSP currentPage={getGaugeValue(location.pathname)} />
      <ConsentTrustTemplate {...tempProps} />
    </form>
  );
};
